import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { LocalizedDatePipe } from '~/core/pipes/localized-date.pipe';
import { LEAVE_MODAL_CONFIG } from '~/organizer/shared/components/shared/layouts/funnel/funnel.component';
import { NAVIGATION_ROUTING } from '~/organizer/shared/components/shared/navigation-buttons/navigation-buttons.component';
import { STEPPER_TAB_BAR_CONFIG } from '~/organizer/shared/components/shared/page-container/page-container.component';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';

import { OrganizerActivityPlanningRoutingModule } from './activity-planning-routing.module';
import { OrganizerActivityPlanningPageActivityComponent } from './components/pages/activity/activity.component';
import { OrganizerActivityPlanningPageMyPlanningValidationComponent } from './components/pages/my-planning-validation/my-planning-validation.component';
import { OrganizerActivityPlanningDateSelectionComponent } from './components/shared/date-selection/date-selection.component';
import { organizerActivityPlanningLeaveModalConfig } from './configs/leave-modal.config';
import { organizerActivityPlanningRoutingConfig } from './configs/routing.config';

@NgModule({
  imports: [
    OrganizerActivityPlanningRoutingModule,
    CommonModule,
    ComponentModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    OrganizerSharedModule,
  ],
  declarations: [
    OrganizerActivityPlanningDateSelectionComponent,
    OrganizerActivityPlanningPageActivityComponent,
    OrganizerActivityPlanningPageMyPlanningValidationComponent,
  ],
  providers: [
    LocalizedDatePipe,
    DatePipe,
    {
      provide: LEAVE_MODAL_CONFIG,
      useValue: organizerActivityPlanningLeaveModalConfig,
    },
    {
      provide: NAVIGATION_ROUTING,
      useValue: organizerActivityPlanningRoutingConfig,
    },
    {
      provide: STEPPER_TAB_BAR_CONFIG,
      useValue: [],
    },
  ],
})
export class OrganizerActivityPlanningModule {}
